var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaundry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laundry",
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.421,
    height: 163.112,
    viewBox: "0 0 147.421 163.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7A4666;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    className: "cls-1",
    d: "M138.312,0H19.109A14.126,14.126,0,0,0,5,14.109V149a14.126,14.126,0,0,0,14.109,14.109h119.2A14.126,14.126,0,0,0,152.421,149V14.109A14.125,14.125,0,0,0,138.312,0ZM14.346,14.109a4.7,4.7,0,0,1,4.7-4.7H138.312a4.73,4.73,0,0,1,4.714,4.7V32.932H14.412ZM142.944,149a4.7,4.7,0,0,1-4.7,4.7H19.109a4.7,4.7,0,0,1-4.7-4.7V42.409h128.6Z",
    transform: "translate(-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    className: "cls-1",
    d: "M74.879,10.1H65.468a4.7,4.7,0,0,0-4.7,4.73h0a4.714,4.714,0,0,0,4.7,4.714h9.412a4.714,4.714,0,0,0,4.7-4.714h0a4.681,4.681,0,0,0-4.7-4.7Z",
    transform: "translate(30.198 6.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    className: "cls-1",
    d: "M90.408,10.1H80.931a4.714,4.714,0,1,0,0,9.412h9.412a4.714,4.714,0,0,0,4.763-4.681h0a4.7,4.7,0,0,0-4.7-4.7Z",
    transform: "translate(39.772 6.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    className: "cls-1",
    d: "M22.31,77.7a45.488,45.488,0,1,0,90.976,0,31.765,31.765,0,0,0-.155-3.637h0a45.492,45.492,0,0,0-90.69,0h0C22.359,75.266,22.31,76.473,22.31,77.7Zm45.476,36.064A36.113,36.113,0,0,1,31.8,80.094a23.292,23.292,0,0,1,2.936,1.631A21.482,21.482,0,0,0,47.4,85.558a21.515,21.515,0,0,0,12.657-3.833,13.44,13.44,0,0,1,15.463,0,22.836,22.836,0,0,0,25.315,0,21.2,21.2,0,0,1,2.936-1.631,36.113,36.113,0,0,1-35.983,33.666Zm0-72.145a36.129,36.129,0,0,1,35.346,28.822A23.472,23.472,0,0,0,95.906,73.7a13.44,13.44,0,0,1-15.463,0,22.836,22.836,0,0,0-25.315,0,13.44,13.44,0,0,1-15.463,0,23.472,23.472,0,0,0-7.226-3.262A36.129,36.129,0,0,1,67.786,41.649Z",
    transform: "translate(5.925 20.334)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/Laundry.00f32e671125ee60a431a371e00ba91c.svg";
export { ForwardRef as ReactComponent };